import moment from 'moment';

const DATE_FORMAT = 'DD MMM YYYY';
const LONG_DATE_FORMAT = 'dddd, MMMM Do YYYY, h:mm a';
const READABLE_DATE_FORMAT = 'MMM DD, YYYY';
const MDY_DATE_FORMAT = 'MM/DD/YYYY';
const MD_DATE_FORMAT = 'MM/DD';

export const formatDate = (date) => moment(date).format(DATE_FORMAT);
export const formatLongDate = (date) => moment(date).format(LONG_DATE_FORMAT);
export const formatReadableDate = (date) =>
  moment(date).format(READABLE_DATE_FORMAT);
export const formatmdy = (date) => moment(date).format(MDY_DATE_FORMAT);
export const formatmd = (date) => moment(date).format(MD_DATE_FORMAT);

export const sumDaysToDate = (days) => {
  const date = new Date();
  date.setDate(date.getDate() + parseInt(days));
  return date;
};

function join(date, options, separator) {
  function format(option) {
    const formatter = new Intl.DateTimeFormat('en', option);
    return formatter.format(date);
  }
  return options.map(format).join(separator);
}

export const formatDateToNumeric = (date) => {
  const options = [
    { day: 'numeric' },
    { month: 'numeric' },
    { year: 'numeric' },
  ];
  return join(date, options, '-');
};

/**
 * Intelligently distributes deadlines across campaign timeline
 * - Randomly avoids some weekends (70% chance to skip)
 * - Adds slight randomization
 * - Ensures strategic spacing
 */
export const calculateStrategicDeadline = ({ startDate, endDate, index, totalBriefs }) => {
  const start = new Date(startDate);
  const end = new Date(endDate);

  // Calculate total days in campaign
  const totalDays = Math.floor((end - start) / (1000 * 60 * 60 * 24));

  // Base interval between briefs
  const baseInterval = totalDays / totalBriefs;

  // Add randomization (±20% of base interval)
  const randomOffset = (Math.random() - 0.5) * baseInterval * 0.4;

  // Calculate target day
  let targetDays = Math.floor(baseInterval * index + randomOffset);

  // Ensure we don't exceed the campaign end
  targetDays = Math.min(targetDays, totalDays - 1);

  // Calculate deadline date
  const deadline = new Date(start);
  deadline.setDate(start.getDate() + targetDays);

  // Randomly skip weekends (70% chance to skip, 30% chance to keep)
  const shouldSkipWeekend = Math.random() < 0.7;
  if (shouldSkipWeekend) {
    const dayOfWeek = deadline.getDay();
    if (dayOfWeek === 6) { // Saturday
      deadline.setDate(deadline.getDate() - 1);
    } else if (dayOfWeek === 0) { // Sunday
      deadline.setDate(deadline.getDate() + 1);
    }
  }

  return deadline;
};
